// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__edDbA","actions":"GroupTable_actions__3c2kR","deleteModalFooter":"GroupTable_deleteModalFooter__1QqIl"};